/* 2026-10-06 MEMORY LEAK FIX (scroll crash came back on theme 3.6):
   Every loaded page used to be parsed TWICE with DOMParser as a full HTML page.
   Chrome never frees a parsed document that contains <video> or <source>
   elements (product card videos; the footer graffiti <picture><source> added in
   3.6 is on EVERY page) -> 2 dead copies of the whole page (~13,500 elements
   each) per scroll step; a big collection reached ~400,000 elements and
   ~1.1 GB, enough to crash a phone tab.
   Now: (1) only the product grid section is fetched (Section Rendering API,
   ~40% fewer bytes, no footer), (2) it is parsed ONCE with the media tags
   renamed so the throwaway document holds no media element, (3) the real
   tags are restored in the HTML that goes into the page.
   Related fixes: global.js (tag-image / video-js / swiper-slider cleanup),
   zara-filters.liquid, footer.liquid park script.
   2026-10-26: replaced by one inert <template> parse + cards added a few per frame (see handler);
   the two helpers below are kept for reference only.
   Regression check before publishing a theme or updating Wokiee:
   scripts/scroll-memory-check.py in the project folder (not part of the theme). */
function infinityMuteMedia(html) {
  return html.replace(/<(\/?)(video|audio|source|track)\b/gi, '<$1ec-muted-$2');
}
function infinityUnmuteMedia(html) {
  return html.replace(/<(\/?)ec-muted-(video|audio|source|track)\b/gi, '<$1$2');
}

class infinityButton extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('.btn');
    this.link&&this.link.addEventListener('click', this.handler.bind(this));
    /* 2026-07-29: scroll handler eskiden HER scroll olayinda (saniyede yuzlerce kez)
       calisiyor ve her seferinde offsetTop okuyup zorunlu reflow tetikliyordu.
       requestAnimationFrame kilidi ile kare basina EN FAZLA 1 kez calisir —
       davranis ayni, maliyet ~10 kat dusuk. Buyuk koleksiyonlarda hizli kaydirmada
       fark edilir (bkz. footer.liquid park mekanizmasi). */
    if (this.classList.contains('autoscroll_yes')) {
      var _this = this;
      this._rafPending = false;
      this._onScroll = function () {
        if (_this._rafPending) return;
        _this._rafPending = true;
        window.requestAnimationFrame(function () {
          _this._rafPending = false;
          _this.autoscrollhandler();
        });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }
  }
  handler(event){
    event.preventDefault();
    if(this.destroyed) return false;
    placeCollectionLoader();
    var loader = document.querySelector('.collection_facets_loader');
    loader.classList.add('loading_now');
    var url = event.currentTarget.href;
    var link = this.link;
    var section = this.closest('.shopify-section');
    var sectionId = section && section.id.indexOf('shopify-section-') === 0 ? section.id.slice(16) : '';
    var sectionUrl = sectionId ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId) : url;
    var load = function (u) {
      return fetch(u).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      });
    };
    load(sectionUrl)
      .catch(function () { if (sectionUrl !== url) return load(url); throw new Error('load failed'); })
      .then(function (responseText) {
        /* 2026-10-26: the page is parsed ONCE, into an inert <template> (its media and images do not
           load and no new document is created per page, so nothing needs muting), and the cards are
           moved into the grid a few per frame (at most ~6 ms per frame). Before, every page was parsed,
           serialized and parsed again, and 48 cards went in at once: a burst of throwaway memory and a
           visible stop on the phone each page (owner's videos: stutters, tab reload on very fast flicks).
           The next-page button goes in only after the last card, so no second page starts meanwhile. */
        var tpl = document.createElement('template');
        tpl.innerHTML = responseText;
        var grid = tpl.content.querySelector('.collection__container');
        var nextButton = tpl.content.querySelector('infinity-button');
        var cards = grid ? Array.prototype.slice.call(grid.children) : [];
        tpl = grid = null;

        var liveGrid = document.querySelector('.collection__container');
        var i = 0;
        var finish = function () {
          var current = document.querySelector('infinity-button');
          if (current && nextButton) current.replaceWith(nextButton);
          cards = nextButton = null;
          loader.classList.remove('loading_now');
        };
        var step = function () {
          var t0 = performance.now();
          while (i < cards.length && performance.now() - t0 < 6) liveGrid.appendChild(cards[i++]);
          if (i < cards.length) requestAnimationFrame(step);
          else finish();
        };
        if (liveGrid && cards.length) requestAnimationFrame(step);
        else finish();
      })
      .catch(function () {
        /* Network error: hide the loader and let auto scroll try again a bit later. */
        loader.classList.remove('loading_now');
        setTimeout(function () { if (link) link.classList.add('autoscroll'); }, 3000);
      });
  }
  autoscrollhandler(){
    if(!this.link || this.destroyed) return false;
    if(!this.link.classList.contains('autoscroll')) return false;
    var contY = parseInt(this.link.parentNode.offsetTop);
    var wY = this.getWindowHeight()+this.getWindowTopY();
    if( contY <= wY ) {
      this.link.classList.remove('autoscroll');
      this.link.dispatchEvent(new Event('click', {bubbles: true, cancelable: true}));
    }
  }
  getWindowHeight(){
    return window.innerHeight;
  }
  getWindowTopY(){
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  disconnectedCallback(){
    this.destroyed = true;
    /* 2026-07-29 SIZINTI DUZELTMESI: her sayfa yuklemesinde handler() bu elemani
       replaceWith() ile YENISIYLE degistiriyor ve yeni eleman window'a YENI bir
       scroll dinleyicisi ekliyordu. Eskisi hic kaldirilmadigi icin 48 sayfalik bir
       koleksiyonda window'da 48 dinleyici birikiyordu (hepsi destroyed kontrolunde
       erken donse de her scroll'da cagriliyorlardi). Artik eleman DOM'dan cikinca
       kendi dinleyicisini de goturuyor. */
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll);
      this._onScroll = null;
    }
    this.remove();
  }
}
customElements.define('infinity-button', infinityButton);
